import { AxiosError } from "axios";
import SHA256 from "crypto-js/sha256";
export const NavigateToLanding = (): void => {
  let url = window.location.origin;
  url = `${url}/landing`;
  window.location.replace(url);
};

export const NavigateNullMsisdn = (): void => {
  const data = getCookie("data");
  if (!data?.msisdn) {
    let url = window.location.origin;
    url = `${url}/landing`;
    window.location.replace(url);
  }
};

export const LogoutUser = (): void => {
  clearAllCookies();
  NavigateToLanding();
};

export const setCookie = (
  msisdn: string | number,
  token: string,
  subscribeId: string | number,
): void => {
  clearAllCookies();
  const data = {
    msisdn: msisdn,
    token: token,
    subscribeId: subscribeId,
  };
  const maxAge = 30 * 24 * 60 * 60;
  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data),
  )}; SameSite=Strict; path=/; max-age=${maxAge}`;
};

export const getCookie = (name: string): any => {
  try {
    const cookies: Record<string, string> = document.cookie
      .split(";")
      .reduce((acc: Record<string, string>, cookie: string) => {
        const [key, value] = cookie.split("=");
        acc[key.trim()] = decodeURIComponent(value);
        return acc;
      }, {});
    return cookies[name] ? JSON.parse(cookies[name]) : null;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};

export const clearAllCookies = (): void => {
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });
};

export const logout = (val: string): void => {
  clearAllCookies();
  if (val === "network") {
    // window.location.href = '/landing'
  }
};

export const getDataFromCookies = (): {
  cookieMsisdn: string | null;
  cookieSubscribeId: string | null;
} => {
  const data = getCookie("data");
  return {
    cookieMsisdn: data?.msisdn || null,
    cookieSubscribeId: data?.subscribeId || null,
  };
};

export const getQueryParams = (param: string): string | null => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  return null;
};
export const sha256Hash = (value: string) => {
  return SHA256(value.trim().toLowerCase()).toString();
};
export const getErrorDataCase = (e: unknown): string => {
  try {
    if (e instanceof AxiosError) {
      if (e.response?.data?.result) {
        return String(e.response.data.result);
      }
      // Common backend pattern: { message: "..." }
      if (e.response?.data?.message) {
        return String(e.response.data.message);
      }
      // Axios error message
      if (e.message) {
        return e.message;
      }
    }
    // Non-Axios errors
    if (e instanceof Error) {
      return e.message;
    }
    return "Something went wrong. Please try again later";
  } catch {
    return "Something went wrong. Please try again later";
  }
};
